import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="sse-logo"></div>
      <p>
        <a href="privacy-policy.html" title="Privacy Policy">
          Privacy Policy
        </a>{" "}
        | Software version 1.01. © Smart Reasturant 2021. All rights reserved.
      </p>
    </footer>
  );
};
export default Footer;
